import React, { Component } from 'react';
import * as util from './util';
import { defaultHeaders } from './util';
import {Header} from './header.js';
import {Footer} from './footer.js';
import './editor.css'
import './suggestion.css';

let faqSuggestion = [];

export class Suggestion extends Component {
  constructor(props) {
    super(props);
    this.getSuggestionContent = this.getSuggestionContent.bind(this);
    this.state = {
      staticHTML: ''
    }
  }

  componentWillMount() {
    if( util.isGuestUser() === true ) {
      util.loginGuest( _ => this.getSuggestionContent());
    } else {
      this.getSuggestionContent();
    }
  }

  getSuggestionContent() {
    const self = this;
    const url = `/api/get-editor-content?type=recommendations`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        alert('Empfehlungen konnten nicht geladen werden.');
        console.error('Could not fetch suggestion content.', exception);
      });
    promise.then(function (json) {
      self.setState({
        staticHTML: json.text.recommendations
      });
      return;
    });
    return;
  }

  render() {
    return (
      <div className="Landing">

          <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
          <div className="ContentWithBackground">
            <div className="content" id="content">
              <div className="contentHeaderText">
                Empfehlungen
              </div>
              <div className="suggestion">
            <div className="marginTop30">
             <div dangerouslySetInnerHTML={{ __html: this.state.staticHTML }} ></div>
                {/*   <InfoBar faq={faqSuggestion} /> */}
                </div>
            </div>
            </div>
          </div>
          <Footer faqs={faqSuggestion}/>
        </div>
      
        )
  }
}



// WEBPACK FOOTER //
// ./src/suggestion.js